/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {toAbsoluteUrl, KTSVG} from '../../../helpers'

type Props = {
  image: string
  title: string
  url: string
}

const CardApplication: FC<Props> = ({
  image,
  title,
  url,
}) => {

  const [imagem, setImagem] = useState(
    image === null? toAbsoluteUrl('/media/logos/errorImage.png') : image
    )

  function erroImagem() {
    setImagem(toAbsoluteUrl('/media/logos/errorImage.png'))
  }

  return (
    <a href={url} target="_blank">
      <div
      className='card border border-top-1 border-left-1
        border-right-1 border-hover bg-hover-light-primary'
    >
      <div className='card-header border-0 p-5 d-flex justify-content-center align-items-center'>
        <div className='w-100 d-flex flex-column align-items-center'>
          <div className='mw-100 mh-100'>
            <img
            className='mw-100 mh-100 rounded'
            src={imagem} alt={title} onError={erroImagem}/>
          </div>
        </div>
      </div>

      <div className='card-body d-flex flex-column p-5 '>
        <div className='fs-1tx text-dark fw-bolder mb-3 ms-1 d-flex flex-column align-items-center'>
          <p className='fs-6 fw-bold text-primary m-0'>{title}</p>
        </div>
      </div>
    </div>
    </a>
  )
}

export {CardApplication}
